<form class="pre-form" #formulari="ngForm">        
    <p i18n>Estudis de grau, llicenciatura o equivalent</p>
    <mat-grid-list [cols]="nombreColumnes()" rows="3" rowHeight="80px">                              
      <mat-grid-tile>
          <mat-form-field class="pre-field">
              <input matInput name="estudi-realitzat-pais" placeholder="País on heu cursat l'estudi" 
                  [matAutocomplete]="auto" [formControl]="paisCtrl" [ngModel]="preinscripcio.estudiRealitzat.pais" required (ngModelChange)="paisChange($event)" i18n-placeholder>
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="utilitats.displayName">
                  <mat-option *ngFor="let x of filteredPaisos | async" [value]="x">                                        
                      {{ x?.name }}
                  </mat-option>
              </mat-autocomplete>
          </mat-form-field>                            
      </mat-grid-tile>
      <mat-grid-tile *ngIf="preinscripcio.estudiRealitzat.paisEspanya()">
          <mat-form-field class="pre-field">
              <input matInput name="estudi-realitzat-universitat" placeholder="Universitat" 
                  [matAutocomplete]="universitat" [formControl]="universitatCtrl"  [ngModel]="preinscripcio.estudiRealitzat.universitat" required (ngModelChange)="universitatChange($event)" i18n-placeholder>
              <mat-autocomplete #universitat="matAutocomplete" [displayWith]="utilitats.displayName">
                      <mat-option *ngFor="let x of filteredUniversitats | async" [value]="x">                                        
                          {{ x?.name }}
                      </mat-option>
              </mat-autocomplete>                                
          </mat-form-field>                            
      </mat-grid-tile>
      <mat-grid-tile *ngIf="!preinscripcio.estudiRealitzat.paisEspanya()">
          <mat-form-field class="pre-field">
              <input matInput name="estudi-realitzat-universitat-text" placeholder="Universitat" [(ngModel)]="preinscripcio.estudiRealitzat.universitatText" required i18n-placeholder>
          </mat-form-field>                            
      </mat-grid-tile>                    
      <mat-grid-tile *ngIf="preinscripcio.estudiRealitzat.paisEspanya()">
          <mat-form-field class="pre-field">
              <input matInput name="estudi-realitzat-estudi" placeholder="Estudis" 
                  [matAutocomplete]="estudi" [formControl]="estudisCtrl" [ngModel]="preinscripcio.estudiRealitzat.estudi" required (ngModelChange)="estudiChange($event)" i18n-placeholder>
              <mat-autocomplete #estudi="matAutocomplete" [displayWith]="utilitats.displayName">
                      <mat-option *ngFor="let x of filteredEstudis | async" [value]="x">                                        
                          {{ x?.name }}
                      </mat-option>
              </mat-autocomplete>                                
          </mat-form-field>                            
      </mat-grid-tile>   
      <mat-grid-tile *ngIf="!preinscripcio.estudiRealitzat.paisEspanya()">
              <mat-form-field class="pre-field">
                  <input matInput  name="estudi-realitzat-estudi-text" placeholder="Estudis" [(ngModel)]="preinscripcio.estudiRealitzat.estudiText" required i18n-placeholder>
              </mat-form-field>                            
          </mat-grid-tile>                                                     
      <mat-grid-tile *ngIf="!preinscripcio.estudiRealitzat.universitatGirona()">
          <mat-form-field class="pre-field">
              <input type="number" matInput  name="estudi-realitzat-nota-mitjana" placeholder="Nota mitjana" 
              [(ngModel)]="preinscripcio.estudiRealitzat.notaMitjana" [formControl]="notaMitjanaInput" i18n-placeholder>
            <mat-error i18n>
                La nota ha d'estar entre 0 i 10!
            </mat-error>
            <mat-hint i18n>
                Nota mitjana calculada sobre 10
            </mat-hint>          
          </mat-form-field>  
      </mat-grid-tile>
      <mat-grid-tile *ngIf="preinscripcio.estudiRealitzat.universitatGirona()" [colspan]="nombreColumnes()">
        <p i18n="@@a867b17e550308b5338b902148c707f6ff3268f1">Tingueu present que, d'acord amb els <a href="https://www.udg.edu/ca/estudia/Acces/Acces-a-masters/Requisits-acces-masters-universitaris" target="_blank">requisits d'accés a màsters</a>, cal fer la sol·licitud del títol acadèmic de grau per poder optar a l’admissió. Podeu demanar-ho a través de <a href="https://lameva.udg.edu/ca-es/Identificacio?returnurl=%2fca-es%2f" target="_blank">La Meva</a> > Expedient > Tràmits.</p>
        <p i18n="@@a867b17e550308b5338b902148c707f6ff3268f1b">Podeu demanar-ho a través de <a href="https://lameva.udg.edu/ca-es/Identificacio?returnurl=%2fca-es%2f" target="_blank">La Meva</a> > Expedient > Tràmits.</p>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="nombreColumnes()">
          <p i18n="@@543aaebba7ea0571f01ba0427c1e7438813642cc">En el cas d'estudiants amb titulacions estrangeres el càlcul de la nota cal realitzar-lo a través de l'enllaç següent: <br/> <a href="https://universidades.sede.gob.es/pagina/index/directorio/Equivalencia_notas_medias" target="_new">https://universidades.sede.gob.es/pagina/index/directorio/Equivalencia_notas_medias</a> <br/> És <strong>obligatori datar i signar</strong> el document a l'apartat "9.</p>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="nombreColumnes()">        
        <p i18n="@@NotaEstudisOrdreAssignatures">Les <strong>assignatures</strong> han d'aparèixer en el <strong>mateix ordre</strong> que al certificat de notes.</p>
    </mat-grid-tile>
    <mat-grid-tile [colspan]="nombreColumnes()" *ngIf="preinscripcio.potModificar">
          <div class="pre-controls-right">
              <button mat-raised-button matStepperPrevious i18n>Torna</button>
              <button mat-raised-button color="primary" (click)="continua()" [disabled]="!isValid()" i18n>Continua</button>            
          </div>
      </mat-grid-tile>
  </mat-grid-list>
</form> 


// WEBPACK FOOTER //
// ./src/app/estudis/estudis.component.html